import { useCallback, type CSSProperties } from "react";
import { AINA_INTRO_VIDEO_URL } from "@repo/utils";
import { registerAinaIntroPrimer } from "../../../lib/aina-intro/primer";

const hostStyle: CSSProperties = {
  position: "fixed",
  left: -9999,
  top: 0,
  width: 4,
  height: 4,
  overflow: "hidden",
  pointerEvents: "none",
  opacity: 0,
};

const videoStyle: CSSProperties = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
};

export function AinaIntroPrimer() {
  const setRefs = useCallback((host: HTMLDivElement | null) => {
    const video = host?.querySelector("video") ?? null;
    registerAinaIntroPrimer(host, video);
  }, []);

  return (
    <div ref={setRefs} aria-hidden style={hostStyle}>
      <video
        src={AINA_INTRO_VIDEO_URL}
        preload="auto"
        playsInline
        muted
        loop={false}
        controls={false}
        disablePictureInPicture
        controlsList="nodownload nofullscreen noremoteplayback"
        style={videoStyle}
      />
    </div>
  );
}
